/*
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description: 
 */
const routers = [
  {
    // 内容列表
    path: '/article/list',
    name: 'article_list',
    component: () => import('./List.vue')
  },
  {
    // 内容表单
    path: '/article/form/:type/:id?/:categoryIds?',
    name: 'article_form',
    component: () => import('./Form.vue')
  },
]
export default routers
